import { Stack } from "@mui/material";
import * as React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { HangarsStateContainer } from "../../../../containers/HangarsStateContainer";
import { RampsStateContainer } from "../../../../containers/RampsStateContainer";
import { RampStateContainer } from "../../../../containers/RampStateContainer";
import { RampEditorPresenter, useLocalRampState } from "./RampEditorPresenter";

type Props = {
  ramp_id: string;
  onClose: () => void;
};

export const RampEditor: React.FC<Props> = ({ ramp_id, ...props }) => {
  React.useEffect(() => {
    // Cleanup function to reset state when component unmounts or ramp_id changes
    return () => {
      useLocalRampState.getState().reset();
    };
  }, [ramp_id]);

  return (
    <HangarsStateContainer isReference={false}>
      <RampsStateContainer isReference={false}>
        <RampStateContainer
          initialState={{
            ramp_id,
            isReference: false,
            includeReferenceImage: true,
          }}
        >
          <RampEditorPresenter {...props} />
        </RampStateContainer>
      </RampsStateContainer>
    </HangarsStateContainer>
  );
};

// Wrapper to use useParams and pass ramp_id to RampEditor
export const RampEditorWrapper = () => {
  const navigate = useNavigate();
  const { id } = useParams(); // Extract the :id from the URL

  return (
    <Stack direction="column" height="100%">
      <RampEditor
        ramp_id={id!} // Pass the id as a prop
        onClose={() => navigate(`/settings?tab=Ramps`)}
      />
    </Stack>
  );
};
